import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { resetFlightItemsFromCheckout, setFlightDateChangeStep } from 'actions/FlightActions'
import { FlightChangeDatesPageStep } from 'components/App/Header/HeaderCheckout/StepsHeaderCheckout/steps/flights'
import { goBack } from 'connected-react-router'

/**
 * Custom hook for handling back navigation in flight date change flow
 * Navigates through each step in reverse order
 */
export function useFlightDateChangeBackNavigation() {
  const dispatch = useAppDispatch()
  const currentStep = useAppSelector(state => state.flights.flightsDateChange.currentStep)

  const handleBack = useCallback(() => {
    switch (currentStep) {
      case FlightChangeDatesPageStep.SELECT_FLIGHTS_TO_CHANGE:
        // If we're on the first step, go back to the previous page
        dispatch(goBack())
        break
      case FlightChangeDatesPageStep.SELECT_DATES_TO_CHANGE:
        // Go back to select flights to change
        dispatch(setFlightDateChangeStep(FlightChangeDatesPageStep.SELECT_FLIGHTS_TO_CHANGE))
        break
      case FlightChangeDatesPageStep.SELECT_NEW_FLIGHTS:
        // Go back to select dates to change
        dispatch(setFlightDateChangeStep(FlightChangeDatesPageStep.SELECT_DATES_TO_CHANGE))
        // Reset flight items from checkout, as user navigates back to the previous step
        dispatch(resetFlightItemsFromCheckout())
        break
      case FlightChangeDatesPageStep.REVIEW_AND_PAY:
        dispatch(setFlightDateChangeStep(FlightChangeDatesPageStep.SELECT_NEW_FLIGHTS))
        // Review and Pay is catered in a new url, so we need to go back as-well
        dispatch(goBack())
        break
      default:
        // Fallback to browser back
        dispatch(goBack())
        break
    }
  }, [currentStep, dispatch])

  return {
    handleBack,
    currentStep,
  }
}
